var App = App || {};

App.SpeedBump = (() => {
    'use strict';

    const uriSchemes = ['javascript:', 'mailto:', 'tel:'];
    let modal;
    let bsModal;

    const init = (exemptList) => {
        modal = document.getElementById('speed-bump');
        bsModal = new bootstrap.Modal(modal);

        document.querySelectorAll('a').forEach((link) => {
            link.addEventListener('click', event => {
                let url = link.getAttribute('href');
                let origin = event.target;

                if (link.hostname !== location.hostname
                    && !exemptList.includes(link.hostname)
                    && url
                    && url.indexOf('#') !== 0
                    && !isUriSchema(url)) {

                    event.preventDefault();
                    event.stopPropagation();
                    triggerModal(url, origin);
                }
            });
        });
    }

    const triggerModal = (url, origin) => {
        bsModal.show();

        let proceedButton = modal.querySelector('[data-speedbump="proceed"]');

        proceedButton.addEventListener('click', () => {
            openNewTab(url)
        }, { once: true });

        modal.addEventListener('hidden.bs.modal', event => {
            origin.focus();
            origin.blur();
        }, { once: true });
    }

    const openNewTab = url => {
        bsModal.hide();
        window.open(url);
    }

    const isUriSchema = url => {
        for (var i in uriSchemes) {
            if (url.indexOf(uriSchemes[i]) > -1) {
                return true;
            }
        }
        return false;
    }

    return {
        init: init
    };
})();